<template>
  <div>
    <ProjectBaseView>
      <v-container v-if="sprint">
        <v-row>
          <v-col cols="12">
              <v-card-title>
                <span class="text-h5">Vista del Sprint</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-card>
                      <v-card-title>Gráfico de Quemado</v-card-title>
                      <v-card-text>
                        <canvas id="burnDownChart"></canvas>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card>
                      <v-card-title>Detalles del Sprint</v-card-title>
                      <v-card-text>
                        <p><strong>Descripción:</strong> {{ sprint.description }}</p>
                        <v-row>
                          <v-col cols="12" md="6">
                          <p><strong>Fecha de Inicio:</strong></p>
                          <v-chip color="primary" text-color="white">{{ new Date(sprint.startDate).toLocaleString() }}</v-chip>
                          </v-col>
                          <v-col cols="12" md="6">
                          <p><strong>Fecha de Término:</strong></p>
                          <v-chip color="primary" text-color="white">{{ new Date(sprint.endDate).toLocaleString() }}</v-chip>
                          </v-col>
                        </v-row>
                        <p><strong>Puntos Totales:</strong> {{ sprint.totalPoints }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                      <v-card-title>Elementos Asociados</v-card-title>
                      <v-card-text>
                        <v-data-table :headers="headers" :items="elements" class="elevation-1">
                            <!-- eslint-disable-next-line -->
                          <template v-slot:item.actions="{ item }">
                            <v-icon small @click="viewElement(item)">mdi-eye</v-icon>
                          </template>
                        </v-data-table>
                      </v-card-text>
                  </v-col>
                </v-row>
              </v-card-text>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col cols="12">
            <v-alert type="error" dismissible>
              No se encontró ningún sprint para este proyecto.
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </ProjectBaseView>
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Filler, ScatterController } from 'chart.js';
import api from '@/api.js';
import ProjectBaseView from './ProjectBaseView.vue';

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, Filler, ScatterController);

export default {
  name: 'SprintsView',
  components: {
    ProjectBaseView
  },
  data() {
    return {
      sprint: {
        description: '',
        startDate: '',
        endDate: '',
        totalPoints: 0,
        history: []
      },
      elements: [],
      headers: [
        { text: 'Descripción', value: 'description' },
        { text: 'Puntaje', value: 'puntaje' },
        { text: 'Estado', value: 'state' },
      ]
    };
  },
  methods: {
    async fetchSprint() {
      try {
        const response = await api.get(`/api/sprint/get/all`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });

        let sprints = response.data;

        console.log('antes de filtrar...', sprints);

        // Filtrar los que pertenecen al proyecto actual
        sprints = sprints.filter(sprint => sprint.project === this.$route.params.projectId);

        // Verificar si hay sprints antes de ordenar
        if (sprints.length === 0) {
          console.warn('No hay sprints para este proyecto');
          this.sprint = null;
          return;
        }

        // Ordenar por createdAt y escoger el último (más reciente)
        console.log('ordenando para obtener el ultimo...', sprints);
        this.sprint = sprints.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

        console.log('sprint seleccionado:', this.sprint);
        this.renderBurnDownChart();
      } catch (error) {
        console.error('Error al obtener el sprint:', error);
      }
    },
    async fetchElements() {
      try {
        const response = await api.get(`/api/element/compromiso/project/${this.$route.params.projectId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        this.elements = response.data.filter(element => element.sprint === this.sprint._id);
      } catch (error) {
        console.error('Error al obtener los elementos:', error);
      }
    },
    renderBurnDownChart() {
      const ctx = document.getElementById('burnDownChart').getContext('2d');
      const data = this.sprint.history.map(entry => ({
        x: new Date(entry.date).toLocaleDateString(),
        y: entry.pointsLeft
      }));

      new ChartJS(ctx, {
        type: 'scatter',
        data: {
          datasets: [
            {
              label: 'Puntos Restantes',
              data: data,
              borderColor: 'rgba(75, 192, 192, 1)',
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              fill: true,
              showLine: true,
              stepped: true
            }
          ]
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              position: 'top'
            },
            title: {
              display: true,
              text: 'Gráfico de Quemado'
            }
          },
          scales: {
            x: {
              type: 'category',
              title: {
                display: true,
                text: 'Fecha'
              }
            },
            y: {
              title: {
                display: true,
                text: 'Puntos Restantes'
              }
            }
          }
        }
      });
    },
    viewElement(element) {
      // Lógica para ver el elemento
      console.log('Ver elemento:', element);
    }
  },
  async created() {
    await this.fetchSprint();
    await this.fetchElements();
  }
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  max-width: 800px; /* Ajusta este valor según necesites */
  margin: 0 auto;   /* Centra el contenedor */
  height: 400px;
  overflow: hidden; /* Evita que el contenido se desborde */
}

#burnDownChart {
  width: 100% !important;
  height: 100% !important;
}
</style>